import { combineReducers } from "redux";
import login from "./authReducers";
import { ListMyPlanReducer } from "./listMyPlanReducer";
import { SocialAddReducer } from "./profileReducer";
import { themeReducer } from "./themeReducer";


export const rootReducers = combineReducers({
    listMyPlan: ListMyPlanReducer,
    login: login,
    socialLink: SocialAddReducer,
    theme: themeReducer
});
